<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BContainer
      class="py-2"
      fluid
    >

      <BRow>

        <BCol
          cols="12"
          md="10"
          class="px-1"
        >
          <BFormGroup
            label="Search"
            label-for="filterLocationSearch"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="filterLocationSearch"
              v-model="tableLocations.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          md="2"
          class="px-1"
        >
          <BFormGroup
            label="Location Type"
            label-for="fLocationType"
            label-class="font-weight-bolder"
          >
            <BFormSelect
              id="fLocationType"
              v-model="tableLocations.filter.location_type"
              :options="tableLocations.options.locationTypes"
            >
              <template #first>
                <BFormSelectOption
                  value=""
                  disabled
                >
                  -- select location type here --
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          class="px-1 mb-2"
        >
          <BButton
            size="sm"
            type="button"
            variant="primary"
            @click.prevent="createLocation"
          >
            Add Location
          </BButton>
        </BCol>

      </BRow>

      <BRow
        class="mt-1"
      >
        <BCol
          cols="12"
          class="px-1"
        >
          <BTable
            ref="tableLocations"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :items="tableProvider"
            :busy="tableLocations.busy"
            :filter="tableLocations.filter"
            :fields="tableLocations.fields"
            :stacked="tableLocations.stacked"
            :sort-by.sync="tableLocations.sortBy"
            :sort-desc.sync="tableLocations.sortDesc"
            :sort-direction="tableLocations.sortDirection"
            :filter-included-fields="tableLocations.filterOn"
            :current-page="tableLocations.currentPage"
            :per-page="tableLocations.perPage"
          >
            <template #cell(index)="{ index }">
              {{ tableRowNumber(tableLocations, index) }}
            </template>

            <template #cell()="{ value }">
              <div class="text-md-nowrap">
                {{ value }}
              </div>
            </template>

            <template #cell(action)="{ item }">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <BButton
                  size="sm"
                  variant="primary"
                  @click.prevent="editLocation(item)"
                >
                  Edit
                </BButton>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <BIcon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </BTable>
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <BFormSelect
            v-model="tableLocations.perPage"
            :options="tableLocations.pageOptions"
            :disabled="tableLocations.busy"
            class="w-100 w-md-25"
            size="sm"
          />
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <BPagination
            v-model="tableLocations.currentPage"
            :total-rows="tableLocations.totalRows"
            :per-page="tableLocations.perPage"
            :disabled="tableLocations.busy"
            aria-controls="table"
            prev-text="Prev"
            next-text="Next"
            first-number
            last-number
            pills
          />
        </BCol>
      </BRow>
    </BContainer>

    <BModal
      id="modalLocation"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      :title="ModalLocationTitle"
      aria-hidden="false"
    >
      <ValidationObserver
        ref="formLocation"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BRow>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="prefix"
                vid="prefix"
                rules="required|max:3"
              >
                <BFormGroup
                  label="Prefix"
                  label-for="prefix"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="prefix"
                    v-model="formLocation.prefix"
                    type="text"
                    autocomplete="off"
                    maxlength="3"
                    placeholder="enter prefix here"
                    :state="(errors.length > 0 ? false : null)"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="location code"
                vid="location_code"
                rules="required|max:30"
              >
                <BFormGroup
                  label="Location Code"
                  label-for="location_code"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="location_code"
                    v-model="formLocation.location_code"
                    type="text"
                    autocomplete="off"
                    maxlength="30"
                    placeholder="enter location code here"
                    :state="(errors.length > 0 ? false : null)"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="location name"
                vid="location_name"
                rules="required|max:100"
              >
                <BFormGroup
                  label="Location Name"
                  label-for="location_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="location_name"
                    v-model="formLocation.location_name"
                    type="text"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="enter location name here"
                    :state="(errors.length > 0 ? false : null)"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="location_type"
                name="location type"
                rules="required"
              >
                <BFormGroup
                  label="Location Type"
                  label-for="fLocationType"
                  label-class="font-weight-bolder"
                >
                  <BFormSelect
                    id="fLocationType"
                    v-model="formLocation.location_type"
                    :options="options.locationTypes"
                    :state="(errors.length > 0 ? false : null)"
                  >
                    <template #first>
                      <BFormSelectOption
                        value=""
                        disabled
                      >
                        -- select location type here --
                      </BFormSelectOption>
                    </template>
                  </BFormSelect>
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="warehouse"
                name="warehouse"
              >
                <BFormGroup
                  label="Warehouse"
                  label-for="warehouse"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <v-select
                    v-model="selected.warehouse"
                    placeholder="search warehouse here"
                    label="warehouse_name"
                    clearable
                    append-to-body
                    input-id="warehouse"
                    :options="(options.warehouses)"
                    :loading="(fetching.warehouses)"
                    :disabled="(state.busy || fetching.warehouses)"
                    :calculate-position="calculateDropPosition"
                    :class="{ 'is-invalid': errors.length > 0 }"
                  >
                    <template #option="{ warehouse_code, warehouse_name }">
                      <div class="d-flex flex-column flex-md-row py-1">
                        <div class="flex-grow-1">
                          {{ warehouse_name }}
                        </div>
                        <strong class="min-w-75px">{{ warehouse_code }}</strong>
                      </div>
                    </template>
                    <template #no-options="">
                      no available warehoue
                    </template>
                  </v-select>
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="allow_in"
                  v-model="formLocation.allow_in"
                  switch
                  value="1"
                  name="allow_in"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Can Stock In?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="allow_out"
                  v-model="formLocation.allow_out"
                  switch
                  value="1"
                  name="allow_out"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Can Stock Out?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>

            <BCol
              v-if="state.editing"
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="is_active"
                  v-model="formLocation.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>
          </BRow>

        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <BButton
          variant="primary"
          tabindex="-1"
          :disabled="state.busy"
          @click.prevent="validateLocation"
        >
          {{ state.editing ? 'Update' : 'Create' }} Location
        </BButton>
        <BButton
          variant="outline-dark"
          tabindex="-1"
          :disabled="state.busy"
          @click.prevent="$event => {
            $event.target.blur()
            cancel()
          }"
        >
          Discard
        </BButton>
      </template>

    </BModal>
  </BContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import QUERY from 'lodash'
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import { SAdminLocation } from '@/services/admin'
import { SSharedList } from '@/services/shared'

export default {
  name: 'VAdminLocations',

  middleware: [
    'auth',
    'admin'
  ],

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Locations'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      fetching: {
        warehouses: false
      },
      options: {
        warehouses: [],
        locationTypes: [
          'Branch',
          'Warehouse',
          'Others'
        ]
      },
      selected: {
        warehouse: ''
      },
      formLocation: {
        id: '',
        warehouse: '',
        prefix: '',
        location_code: '',
        location_name: '',
        location_type: '',
        allow_in: '',
        allow_out: '',
        active: 1
      },
      tableLocations: {
        busy: false,
        fetching: {
          warehouses: false
        },
        options: {
          warehouses: [],
          locationTypes: [
            'All',
            'Branch',
            'Warehouse',
            'Others'
          ]
        },
        selected: {
          warehouse: ''
        },
        filter: {
          search: '',
          location_type: 'All'
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 13, key: 'action', class: 'text-center' },
          { mobile: 12, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 1, key: 'location_type', class: 'min-w-100px' },
          { mobile: 2, key: 'prefix', class: 'text-center min-w-50px' },
          { mobile: 3, key: 'location_code', class: 'min-w-100px' },
          { mobile: 4, key: 'location_name', class: 'min-w-175px' },
          { mobile: 5, key: 'location_name', class: 'min-w-175px' },
          { mobile: 6, key: 'warehouse.warehouse_name', label: 'Warehouse', class: 'min-w-175px' },
          { mobile: 7, key: 'active', class: 'text-center', formatter: this.yesOrNo },
          { mobile: 8, key: 'allow_in', class: 'text-center', formatter: this.yesOrNo },
          { mobile: 9, key: 'allow_out', class: 'text-center', formatter: this.yesOrNo },
          { mobile: 10, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalLocationTitle () {
      return this.state.editing ? 'Edit Location' : 'Add Location'
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },

  watch: {
    'selected.warehouse' (warehouse) {
      this.formLocation.warehouse = warehouse?.id || ''
    },

    'tableLocations.selected.warehouse' (warehouse) {
      this.tableLocations.filter.warehouse = warehouse?.id || ''
    }
  },
  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableLocations.busy = true

      const filters = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        location_type: filter.location_type
      }

      return await SAdminLocation.get(filters).then(({ data }) => {
        this.tableLocations.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        this.tableLocations.totalRows = 0
        return []
      }).finally(() => {
        this.tableLocations.busy = false
      })
    },

    async getWarehouses () {
      this.fetching.warehouses = true
      return await SSharedList.getWarehouses().then(
        ({ data }) => {
          this.options.warehouses = data
        }
      ).catch(() => {
        this.options.warehouses = []
      }).finally(() => {
        this.fetching.warehouses = false
      })
    },

    createLocation () {
      this.state.editing = false

      this.formLocation = {
        id: '',
        prefix: '',
        location_code: '',
        location_name: '',
        location_type: '',
        warehouse: '',
        allow_in: 0,
        allow_out: 0,
        active: 1
      }

      this.selected.warehouse = ''

      this.getWarehouses()

      this.$bvModal.show('modalLocation')
    },

    editLocation (location) {
      this.state.editing = true

      this.formLocation = Object.assign(this.formLocation, {
        id: location.id,
        prefix: location.prefix,
        location_code: location.location_code,
        location_name: location.location_name,
        location_type: location.location_type,
        allow_in: location.allow_in,
        allow_out: location.allow_out,
        active: location.active
      })

      this.getWarehouses().finally(() => {
        this.selected.warehouse = QUERY.find(this.options.warehouses, {
          id: Number(location.warehouse_id)
        }) || ''
      })

      this.$bvModal.show('modalLocation')
    },

    async validateLocation (event) {
      event.preventDefault()
      await this.$refs.formLocation.validate().then(
        async validLocation => {
          if (!validLocation) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: () => {
              if (this.state.editing) {
                return '<h6>Update Location?</h6>'
              }

              return '<h6>Create Location?</h6>'
            },
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.updateLocation()
              }
              return this.submitLocation()
            }
          })
        }
      )
    },

    async submitLocation () {
      return await SAdminLocation.post(this.formLocation).then(
        ({ data: { message } }) => {
          this.$bvModal.hide('modalLocation')
          this.swalSuccess(message).then(() => {
            this.$refs.tableLocations.refresh()
          })
        }
      ).catch(({ message }) => {
        this.$refs.formLocation.setErrors(message)
      }).finally(() => {
        this.state.busy = false
      })
    },

    async updateLocation () {
      return await SAdminLocation.put(this.formLocation).then(
        ({ data: { message, location } }) => {
          this.$bvModal.hide('modalLocation')
          this.swalSuccess(message).then(() => {
            const tableLocationsRow = QUERY.find(this.$refs.tableLocations.localItems, {
              id: Number(location.id)
            })
            if (tableLocationsRow) {
              tableLocationsRow.warehouse = location.warehouse
              tableLocationsRow.warehouse_id = location.warehouse_id
              tableLocationsRow.prefix = location.prefix
              tableLocationsRow.location_type = location.location_type
              tableLocationsRow.location_code = location.location_code
              tableLocationsRow.location_name = location.location_name
              tableLocationsRow.allow_in = location.allow_in
              tableLocationsRow.allow_out = location.allow_out
              tableLocationsRow.active = location.active
              tableLocationsRow.updated_at = location.updated_at
            }
          })
        }
      ).catch(({ message }) => {
        this.$refs.formLocation.setErrors(message)
      }).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
